import { render, staticRenderFns } from "./DoaReason.vue?vue&type=template&id=f5dd03b4&scoped=true&"
import script from "./DoaReason.vue?vue&type=script&lang=js&"
export * from "./DoaReason.vue?vue&type=script&lang=js&"
import style0 from "./DoaReason.vue?vue&type=style&index=0&id=f5dd03b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dd03b4",
  null
  
)

export default component.exports